export default {
  common: {
    appName: 'Chaild Preschool',
    welcome: 'ようこそ',
    login: 'ログイン',
    logout: 'ログアウト',
    save: '保存',
    cancel: 'キャンセル',
    delete: '削除',
    deleteConfirm: '削除しますか？',
    saved: '保存しました',
    edit: '編集',
    add: '追加',
    search: '検索',
    loading: '読み込み中...',
    error: 'エラー',
    success: '成功',
    confirm: '確認',
    back: '戻る',
    next: '次へ',
    submit: '送信',
    close: '閉じる',
    yes: 'はい',
    no: 'いいえ',
    date: '日付',
  },
  auth: {
    signIn: 'サインイン',
    signOut: 'サインアウト',
    email: 'メール',
    password: 'パスワード',
    forgotPassword: 'パスワードをお忘れですか？',
    rememberMe: 'ログイン状態を保持',
    loginSuccess: 'ログインに成功しました',
    loginFailed: 'ログインに失敗しました',
    logoutSuccess: 'ログアウトしました',
  },
  navigation: {
    home: 'ホーム',
    profile: 'プロフィール',
    settings: '設定',
    notifications: '通知',
    toTodayRecord: '本日の記録へ',
    toParentsRecord: '家庭での記録へ',
  },
  settings: {
    title: '設定',
    language: '言語',
    theme: 'テーマ',
    notifications: '通知',
    privacy: 'プライバシー',
    about: 'について',
    eventCalendar: 'イベントカレンダー',
    switchNursery: '園の切り替え',
    notificationSettings: '通知の設定',
    logout: 'ログアウト',
    absentContact: '欠席連絡',
    pickupChange: '送迎変更',
    chat: 'チャット',
    newApplication: '新規申請',
    applicationApproval: '申請承認',
    applicationRejection: '申請却下',
    both: '両方',
    pushOnly: 'PUSHのみ',
    emailOnly: 'メールのみ',
    noNotification: '通知なし',
    currentNursery: '設定中の園',
    selectNursery: '園を選択してください',
    change: '変更',
  },
  errors: {
    notFound: 'ページが見つかりません',
    serverError: 'サーバーエラー',
    networkError: 'ネットワークエラー',
    unauthorized: '権限がありません',
    forbidden: 'アクセスが拒否されました',
    validationError: '無効なデータ',
    E000: 'システムに予期せぬエラーが発生しました。しばらく時間をおいてアクセス頂くかカスタマーサポートにお問い合わせください。',
    E001: 'API仕様書で指定されているのとパラメータが違います。',
    E002: 'トークンが失効しています。',
    E003: 'ユーザーが存在しません',
    E004: 'ユーザーが既に存在しています。',
    E005: '指定されたObjectTypeが不正です。',
    E006: '朝食の記録が存在しません。',
    E007: '朝食の記録が既に存在します。',
    E008: '夕食の記録が存在しません。',
    E009: '夕食の記録が既に存在します。',
    E010: '排便の記録が存在しません。',
    E011: 'ミルクの記録が存在しません。',
    E012: '睡眠の記録が存在しません。',
    E013: '体温の記録が存在しません。',
    E014: '保育日誌の記録が存在しません。',
    E015: '保育日誌の記録が既に存在します。',
    E016: '喫食の記録が存在しません。',
    E017: '喫食の記録が既に存在します。',
    E018: '欠席期間に重複があるため登録できません。',
    E019: '選択された理由が不正です。',
    E020: '選択された送迎者が不正です。',
    E021: 'メッセージが見つかりません。',
    E022: '送迎のデータが見つかりません。',
    E023: 'クラスが見つかりません。',
    E024: '指定した園児が見つかりません。',
    E025: '指定した園児は既に自分の家族として登録されています。',
    E026: '指定した家族が見つかりません。',
    E027: 'ユーザーが指定された家族に所属していません。',
    E028: '指定されたユーザーは既に指定された家族に招待されています',
    E029: '指定のフォーマットが見つかりません',
    E030: '園児IDが指定されていません',
    E031: '指定されたフィード情報が存在しません。',
    E032: '指定されたフィードの詳細情報が存在しません。',
    E033: '指定されたレポートはユーザーのものではありません。',
    E034: '指定された日付の登園・降園の記録が既に存在します。',
    E035: '登園・降園の記録が存在しません。',
    E036: '指定された日付の登園記録がありません。',
    E037: '指定された日付の登園記録が既に存在します。',
    E038: '指定された日付の降園記録が既に存在します。',
    E039: '指定された登園・降園の記録はこの園児のものではありません。',
    E040: '不正な保育園が指定されました。',
    E041: '平仮名の判定に失敗しました。恐れ入りますがお問い合わせください。',
    E042: '内部的に使用されているIDが不正です。',
    E043: 'uqidが不正です。',
    E044: 'CheckSumが不正です。',
    E045: '指定された献立は存在しません。',
    E046: '管理者ユーザーのみが許可された操作です。',
    E047: '指定したクラスは指定した保育園に所属していません',
    E048: '指定した日時、種類の献立は既に存在しています。',
    E049: '指定した献立は指定した保育園の物ではありません。',
    E050: 'ユーザーは指定した保育園に所属していません。',
    E051: '管理者ユーザーのみが許可された操作です。',
    E052: '日誌の承認ステータスが不正です。',
    E053: '園日誌の記録が存在しません。',
    E054: 'このユーザーには承認権限がありません。',
    E055: 'この園日誌の記録者はこのユーザーではありません。',
    E056: 'この園日誌は申請中ではありません。',
    E057: '同一の権限で、他のユーザーが既に承認しています。',
    E058: '日誌の初回作成時の状態は、申請・下書きのいずれかである必要があります。',
    E059: 'おたよりの記録が存在しません。',
    E060: 'このユーザーは指定した献立の保育園に所属していません。',
    E061: '指定した献立に対する検食記録は既に存在しています。',
    E062: '指定された検食記録は存在しません。',
    E063: '指定した年間行事は存在しません。',
    E064: '指定したクラスIDは指定した保育園の物ではありません。',
    E065: 'socketIdの形式が不正です。恐れ入りますがシステム管理者にお問い合わせください。',
    E066: '午睡チェックパターンが存在しません。',
    E067: '担当スタッフが重複しています。',
    E068: '指定したスタッフは指定した保育園に所属していません。',
    E069: 'この午睡チェックパターンはこの園のものではありません。',
    E070: 'この園児はこの保育園に所属していません。',
  },
  messages: {
    confirmDelete: '本当に削除しますか？',
    saveSuccess: '保存に成功しました',
    saveFailed: '保存に失敗しました',
    deleteSuccess: '削除に成功しました',
    deleteFailed: '削除に失敗しました',
  },
  communication: {
    title: '連絡',
    chat: 'チャット',
    newMessage: '新規メッセージ',
    newBroadcastMessage: '新規一斉メッセージ',
    draft: '下書き',
    draftList: '下書き一覧',
    readySendBox: '送信済みBOX',
    readySendBoxTitle: '送信準備BOX',
    send: '送信',
    sending: '送信中...',
    sent: '送信済み',
    saveToDraft: '下書きに保存',
    saveToReadySend: '送信準備BOXに保存',
    savedToDraft: '下書きに保存しました',
    savedToReadySend: '送信準備BOXに保存しました',
    sentSuccess: '送信しました',
    confirm: '確認する',
    confirmed: '確認済み',
    read: '既読',
    viewOnly: '※閲覧のみ',
    contactEmail: '【連絡メール】',
    goToDraft: '下書きへ',
    goToReadySendBox: '送信準備BOXへ',
    openDraft: '下書きを開く',
    openReadySendBox: '送信準備BOXを開く',
    createBroadcastMessage: '一斉メッセージを作成',
    absenceConfirmDelete: '欠席確認・削除へ',
    deleteConfirm: '削除しますか？',
    deleted: '削除しました',
    copyText: 'テキストをコピー',
    copied: 'コピーしました',
    copyFailed: 'コピー失敗しました',
    showAttachment: '添付ファイルを表示する',
    enterComment: 'コメントを入力',
    noClassAssigned: 'クラスが設定されておりません。',
    pdfFallback: '表示されない時の表示',
    downloadPdf: 'PDF をダウンロード',
    // 新機能
    attendanceList: '出席リスト',
    noteList: 'ノートリスト',
    absenceList: '欠席リスト',
    chatList: 'チャット',
    hamburgerMenu: 'ハンバーガーメニュー',
    deleteAttendanceConfirm: '出席確認を削除',
    attendanceNote: '出席メモ',
    draftsList: '下書きリスト',
    readySendBoxList: '送信準備ボックス',
    createBulkMessage: '一括メッセージを作成',
    individualMessages: '個別対応',
    noSavedMessages: '保存メールがありません',
    
    // Attendance Summary
    currentChildrenCount: '現在の園児人数',
    absent: 'お休み',
    person: '人',
    persons: '人',
    inChargeClass: '担当クラス',
  },
  
  // Diary
  diary: {
    draft: '下書き',
    applied: '申請済み',
    approved: '承認済み',
    saveDraft: '下書き保存',
    savedDraft: '下書きを保存しました',
    saveAndApply: '保存して申請',
    reject: '差戻し',
    approve: '承認',
    confirmReject: '本当に取消しますか？',
    willBeRejected: '申請者に差戻しされます。',
    cancel: 'キャンセル',
    chief: '主任',
    director: '施設長',
    freeRecord: '自由記録',
    event: '園行事 / 来訪者',
    earlyLeaver: '早退者 (理由)',
    applicant: '申請者',
    approverChief: '承認者 (主任)',
    approverDirector: '承認者 (施設長)',
    activity: '活動内容',
    handover: '引き継ぎ・伝達事項',
    remarks: '備考',
    staff: '担当者',
    approver: '承認者',
    cancelApproval: '承認取消（差戻し）',
  },
  
  // Comment/Memo
  comment: {
    placeholder: 'コメントを入力',
    save: '保存',
    saved: 'コメントを保存しました',
  },
  
  absence: {
    listTitle: '欠席者一覧',
    noAbsences: '欠席者はいません。',
    reason: '理由',
    title: '欠席登録',
    period: '期間',
    detail: '詳細',
    comment: 'コメント',
    send: '送信',
    infection: '感染症',
    othersWithComment: 'その他（コメントの入力が必要）',
    required: '必須入力項目です',
    deleteTitle: '欠席削除',
    deleteConfirm: '本当にこの欠席記録を削除しますか？',
    delete: '削除',
  },

  records: {
    notSharedWithParents: 'このページの記載内容は保護者には共有されません',
    parentsRecordTitle: '家庭での記録',
    addRecord: '+ 記録を追加',
    addRecordTitle: '記録を追加',
    editDeleteRecord: '記録を修正・削除',
    sleepTime: '睡眠時間',
    sleep: '睡眠',
    temperature: '体温',
    breakfast: '朝食',
    dinner: '夕食',
    milk: 'ミルク',
    defecation: '排便',
    unknown: '不明',
    noRecord: '記録がありません',
    classSelection: 'クラス選択',
    defaultContent: '特記事項なし',
    noClassAssigned: 'クラスが設定されておりません。',
  },

  attendance: {
    checkedIn: '登園済み',
    checkedOut: '降園済み',
    absent: 'おやすみ',
    pickupChanged: '送迎変更',
    inCharge: '担当クラス',
    attendance: '出席',
  },

  defecation: {
    hard: '硬い',
    normal: '普通',
    soft: '柔らかい',
    diarrhea: '水様便（下痢）',
  },

  absenceReason: {
    fever: '発熱',
    personal: '家庭の事情',
    infStrep: '溶連菌感染症',
    infMycoplasma: 'マイコプラズマ肺炎',
    infHFMD: '手足口病',
    infSlappedCheek: '伝染性紅斑（りんご病）',
    infStomach: 'ウイルス性胃腸炎（ノロ、ロタ、アデノ等）',
    infHerpangina: 'ヘルパンギーナ',
    infRS: 'RSウィルス感染症',
    infZoster: '帯状疱疹',
    infRoseola: '突発性発しん',
    infImpetigo: '伝染性膿痂疹（とびひ）',
    covid19: '新型コロナウイルス',
    others: 'その他',
  },

  form: {
    recipient: '宛先',
    title: 'タイトル',
    content: '内容',
    saveToDraft: '下書きへ保存',
    saveToReadyBox: '送信準備BOXへ保存',
    sendNow: 'いますぐ送信',
    // Button labels (2 lines)
    draftLine1: '下書き',
    draftLine2: '保存',
    readyLine1: '送信準備BOX',
    readyLine2: '保存',
    sendLine1: 'いますぐ',
    sendLine2: '送信',
  },

  validation: {
    required: '必須入力項目です',
    choice2: '2つ選択してください',
    counter: '20文字以内で入力してください',
    counter100: '100文字以内で入力してください',
    counter500: '500文字以内で入力してください',
    counter1000: '1000文字以内で入力してください',
    typeNumber: '数値で入力してください',
    email: 'メールアドレスの形式で入力してください',
    phoneNumber: '電話番号の形式が違います',
    postalCode: '郵便番号の形式が違います',
    integerThan0: '0以上の整数で入力してください',
    multipleSelectRequired: '必須入力項目です',
  },

  meal: {
    allFinished: 'すべて完食',
    stapleFood: '主食',
    mainDish: '主菜',
    sideDish: '副菜',
    soup: '汁もの',
    dessert: 'デザート',
    milk: '牛乳',
    snack: 'おやつ',
    status: {
      refill: 'おかわり',
      finished: '完食',
      unfinished: '少し残した',
      half: '半分食べた',
      little: '少し食べた',
      notEat: '食べなかった',
      notServed: '未提供',
    },
  },

  classDiary: {
    classDiary: 'クラス日誌',
    tabRecords: '記録',
    tabDiary: '日誌',
    tabMeal: '喫食',
    diary: '日誌',
    aim: 'ねらい',
    activityMorning: '活動内容　午前',
    activityAfternoon: '活動内容　午後',
    evaluation: '評価と反省',
    parentSupport: '保護者支援',
    applicant: '申請者',
    cancelApplication: '申請解除',
    applied: '申請済',
    apply: '申請',
    applicationSubmitted: '申請しました',
  },

  others: {
    nurseryDiary: '園日誌',
    extendedCareDiary: '延長保育日誌',
  },
  
  // Tab Bar Navigation
  tabBar: {
    communication: '連絡',
    record: '記録',
    other: 'その他',
    settings: '設定',
  },
  
  // Date Navigation
  date: {
    previousDay: '前日',
    nextDay: '翌日',
    previousMonth: '前月',
    nextMonth: '翌月',
    daysOfWeek: ['日', '月', '火', '水', '木', '金', '土'],
    daysOfWeekFull: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
  },
  
  // Filter Dialog
  filter: {
    classFilter: 'クラス絞り込み',
    fiscalYear: '年度',
    noClassesInYear: 'この年度にクラスがありません',
    clear: 'クリア',
    apply: '保存',
    yearFormat: '{year}年度',
  },

  // Temperature Modal
  temperature: {
    beforeCorrection: '修正前：',
    averageTemperature: '平均体温：',
    timeLabel: '時間',
    temperatureLabel: '体温',
  },

  // Milk Modal
  milk: {
    beforeCorrection: '修正前：',
    timeLabel: '時間',
    amountLabel: '量',
    milkTypeLabel: 'ミルク',
    unknown: '不明',
    breastMilk: '母乳',
    formulaMilk: 'ミルク',
    formulaPowderMilk: '粉ミルク',
  },

  // Sleep Modal
  sleep: {
    beforeCorrection: '修正前：',
    sleepLabel: '睡眠',
    startTime: '開始',
    endTime: '終了',
    duration: '時間',
  },

  // Defecation Modal
  defecationModal: {
    beforeCorrection: '修正前：',
    defecationLabel: '排便',
    timeLabel: '時間',
    stateLabel: '状態',
  },

  memoru: {
    albumListTitle: 'アルバム一覧',
    addAlbumButton: '+ アルバムを追加する',
    tabAll: 'すべて',
    tabPublished: '公開中',
    tabUnpublished: '非公開中',
    createAlbumTitle: 'アルバムを作成',
    year: '年度',
    class: 'クラス',
    albumTitle: 'アルバムのタイトル',
    comment: 'コメント',
    publishStartLabel: '公開開始日 *',
    publishNow: 'すぐに公開',
    publishEndLabel: '公開終了日',
    noLimit: '制限なし',
    createAsPrivate: '非公開で作成する',
    create: '作成',
  },
  signup: {
    noNurseryFound: '所属している園が見つかりません。管理画面より保育士アカウントの登録を行ってください。',
    goToTop: 'topページへ',
    logout: 'ログアウト',
  },

  aiReport: {
    title: 'VEVOレポート',
    fiscalYear: '年度',
    quarterLabel: '第{quarter}クォーター',
    quarterShort: '第{quarter}Q',
    entry: {
      title: 'VEVOレポート',
      description: '3か月単位の発達まとめを確認・再生成',
    },
    status: {
      published: '公開済',
      draft: '下書き',
      notGenerated: '未作成',
    },
    languages: {
      en: '英語',
      ja: '日本語',
      ko: '韓国語',
      zh: '中国語',
      vi: 'ベトナム語',
      km: 'クメール語',
      hi: 'ヒンディー語',
      ru: 'ロシア語',
      bn: 'ベンガル語',
      mn: 'モンゴル語',
      tl: 'タガログ語',
      ms: 'マレー語',
    },
    top: {
      yearLabel: '{year}年度',
      totalChildren: '/ {count}',
      empty: 'この年度はまだレポートが生成されていません。施設Webから一括生成を実行してください。',
    },
    quarter: {
      subtitle: '{year}年度・第{quarter}クォーター ({monthsLabel})',
      classChildCount: '{count}名',
      achievedItemCount: '達成項目数: {count}個',
      progressRecordCount: '経過記録数: {count}件',
      generationCount: '生成回数: {count}回',
      publishedAt: '公開日: {date}',
      noClasses: '対象クォーターのクラスがありません。',
    },
    detail: {
      subtitle: '{className} / {ageLabel} ・ {year}年度 {monthsLabel} 期',
      coverageWarning: '対象月のうち {months} のデータのみで生成されました。',
      coverageNone: 'なし',
      coverageMonths: '{months}月',
      contentTitle: 'レポート本文',
      charCount: '{count} 文字',
      notGenerated: 'まだ生成されていません。',
      publish: '公開する',
      revertToDraft: '下書きに戻す',
      regenerate: '再生成',
      noDataTooltip: '対象期間に発達記録がないため再生成できません',
      regeneratingInProgress: '再生成中です...',
      operationLog: '操作ログ',
      lastGenerated: '最終生成: {date}',
      lastPublished: '最終公開: {date}',
      publishedNotice: '公開済のため、施設Webからの一括再生成ではスキップされます。再生成するには先に「下書きに戻す」を実行してください。',
    },
    confirm: {
      publishTitle: '{name} さんのレポートを公開します',
      revertTitle: '{name} さんのレポートを下書きに戻します',
      publishMessage: '保護者に通知が送信されます。よろしいですか？',
      revertMessage: '保護者からは見えなくなります。よろしいですか？',
    },
    regenerateDialog: {
      title: 'VEVOレポートを再生成',
      description: '{name} さんのレポートを再生成します。',
      translateNotice: '現在の本文を選択した言語に翻訳して上書きします。',
      asyncNotice: '非同期処理のため完了まで数十秒〜数分かかります。完了後ステータスは下書きに戻ります。',
      modeSimple: '単純な再生成',
      modeTranslate: '翻訳',
      targetLanguage: '翻訳先の言語',
      processing: '再生成中...',
      completed: '完了しました。',
      failed: '失敗しました。',
      translate: '翻訳',
      start: '開始',
    },
  },
}
